import { useContext } from "react";

import { useTranslation } from "react-i18next";

import formatDistance from "../utilities/formatDistance";
import createGeoUri from "../utilities/createGeoUri";

import Button from "./common/Button";
import Icon from "./Icon";

import DOMPurify from "dompurify";

import { LangContext } from "../context/lang-context";

function Contact(props) {
  const { t, i18n } = useTranslation(),
        { lang } = useContext(LangContext);

  let mail = props.data.contact.mail,
      phone = (props.data.contact.phone) ? props.data.contact.phone.replace(/\s/g, "") : false,
      coordination = props.data.coordination,
      name = props.data.name,
      address = props.data.address;
  
  const bgmap = (props.bgmap) ? `url('${props.bgmap}')`:`url('${process.env.PUBLIC_URL}/images/map.png')`;

  if(props.addressOnly)
  return (
    <>
    <a 
        className="tw-flex tw-items-center tw-mt-2 sx:tw-mt-4 tw-group"
        href={createGeoUri(
          coordination.latitude,
          coordination.longitude,
          props.data.name
        )}
        target="_blank"
        rel="noopener">
        <Icon
            icon="standort"
            size={32}
            className="tw--ml-1 tw-mr-1 group-hover:tw-text-black"
        />
         <span className="tw-text-base">
              {address.street}
              <br />
              {address.zipcode + " " + address.city}
          </span>
      </a>
      { phone && 
      <a className="tw-flex tw-items-center tw-mt-2 sx:tw-mt-4 tw-group" href={
        "tel:"+phone
      }>
        <Icon
          icon="telefon"
          size={32}
          className="tw--ml-1 tw-mr-1 group-hover:tw-text-black"
        />
        <span className="tw-text-base">
          {phone}
        </span>
      </a>
      }
      { mail &&
      <a className="tw-flex tw-items-center tw-mt-2 sx:tw-mt-4 tw-group"
         href={"mailto:" + mail} >
        <Icon
          icon="mail"
          size={32}
          className="tw--ml-1 tw-mr-1 group-hover:tw-text-black"
        />
        <span className="tw-text-base">
            {mail}
        </span>
      </a>}
      {/*props.data.lgf && (
             <a className="tw-flex tw-items-center tw-mt-4 tw-group"
             href="https://mypuregym.swiss/live-group-fitness"
             target="_blank" >
            <Icon
              icon="live_groupfitness"
              size={32}
              className="tw--ml-1 tw-mr-1 group-hover:tw-text-black"
            />
            <span className="tw-text-base">
                Live Group Fitness
            </span>
          </a>
      )*/}
    </>);

  return (
    <>
      <div className="md:tw-flex md:tw-space-x-5 md:tw-mb-12">
        <div
          className="tw-bg-gray-medium tw-aspect-[3/2] md:tw-aspect-square tw-flex tw-items-end tw-justify-center tw-bg-center tw-bg-no-repeat tw-bg-cover tw-p-5 md:tw-self-start md:tw-w-1/3 md:tw-rounded-xl"
          style={{
            backgroundImage: bgmap,
          }}
        >
          <Button
            className="tw-bg-white"
            color="black"
            type="outline"
            size="small"
            title={t("overview.show_map")}
            href={createGeoUri(
              coordination.latitude,
              coordination.longitude,
              name
            )}
            target="_blank"
            rel="noopener"
          />
        </div>
        <div className="md:tw-bg-gray-light md:tw-flex-1 md:tw-w-2/3 md:tw-rounded-xl">
          <div className="tw-p-5 md:tw-p-8">
            <div className="tw-font-condensed tw-font-black tw-text-xl md:tw-text-3xl tw-uppercase tw-italic tw-leading-5">
              {t("overview.contact")}
            </div>
            <div className="tw-mt-5 tw-flex tw-flex-col tw-space-y-3">
              <div className="tw-flex tw-align-start">
                <Icon
                      icon="standort"
                      size={24}
                      className="tw-flex-none tw--ml-1 tw-mr-2"
                    />
                  <a
                    className="tw-flex tw-align-start tw-group"
                    href={createGeoUri(
                      coordination.latitude,
                      coordination.longitude,
                      address.name
                    )}
                    target="_blank"
                    rel="noopener"
                  >
                    
                    <span className="group-hover:tw-text-teal">
                      {address.street}
                      <br />
                      {address.zipcode + " " + address.city}
                    </span>
                  </a>
              </div>
              <div className="tw-flex tw-align-start">
                { phone && <Icon
                  icon="telefon"
                  size={24}
                  className="tw-flex-none tw--ml-1 tw-mr-2"
                />}
                { phone && <a
                  href={
                    "tel:" +
                    phone
                  }
                >
                  {phone}
                </a>}
              </div>
              <div className="tw-flex tw-align-start">
              { mail && <Icon
                  icon="mail"
                  size={24}
                  className="tw-flex-none tw--ml-1 tw-mr-2"
                />}
                { mail &&
                <span>
                  <a
                    className="hover:tw-text-teal"
                    href={"mailto:" + mail}
                  >
                    {mail}
                  </a>
                </span>
                }
              </div>
            </div>
          </div>
          {props.data.optionalData?.arrival &&
            props.data.optionalData.arrival[lang] &&
            props.data.optionalData.arrival[lang] !==
              "<p><strong>Mit dem Auto:</strong> Lorem Ipsum........</p><p><strong>Mit den OV:</strong> Lorem Ipsum........</p>" && (
              <div className="tw-p-5 md:tw-p-8">
                <div className="tw-font-condensed tw-font-black tw-text-xl md:tw-text-3xl tw-uppercase tw-italic tw-leading-5">
                  {t("overview.arrival")}
                </div>
                <div
                  className="tw-mt-5 [&>*+*]:tw-mt-5"
                  dangerouslySetInnerHTML={{
                    __html: DOMPurify.sanitize(
                      props.data.optionalData.arrival[lang]
                    ),
                  }}
                ></div>
              </div>
            )}
          {!!props.data?.neighbor?.length && props.data?.neighbor && (
            <div>
              <div className="tw-p-5 md:tw-px-8 md:tw-pb-1 tw-font-condensed tw-font-black tw-text-xl md:tw-text-3xl tw-uppercase tw-italic tw-leading-5">
                {t("overview.neighbors")}
              </div>
              <ul className="tw-grid tw-grid-cols-2 md:tw-p-3">
                {props.data.neighbor.map((neighbor, index) => {
                  return (
                    <li className="tw-px-5 tw-py-2" key={"neighbor_" + index}>
                      <a
                        className="tw-block tw-group"
                        href={props.data.neighbor[index]?.link}
                      >
                        <div className="group-hover:tw-text-black tw-text-teal tw-font-bold tw-underline">
                          {neighbor.name}
                        </div>
                        <div className="">
                          {formatDistance(neighbor.coordination.distance)}
                        </div>
                        <div className="">
                          {neighbor.address.street}
                          <br />
                          {neighbor.address.zipcode +
                            " " +
                            neighbor.address.city}
                        </div>
                      </a>
                    </li>
                  );
                })}
              </ul>
              <div className="tw-p-5 md:tw-p-8">
                <Button
                  size="large"
                  color="teal"
                  type="fill"
                  title={t("overview.show_all_clubs")}
                  className="tw-mb-12 tw-w-full md:tw-w-auto"
                  href={t("links.all_studios")}
                />
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
}

export default Contact;
